module.exports = __webpack_public_path__ + "static/media/gorra (2).cfcd10cc.png";